'use client';

import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeMediaAssetsResponseData } from '@/lib/api/playbackService/types';

export default function useCourseMediaAssets(courseAnchor: string) {
  const { data, error, mutate } = useSWR<TypeMediaAssetsResponseData, Error>(
    `${API_URLS.PLAYBACK_SERVICE_PROXY}/courses/${courseAnchor}/media_assets`,
    { ...SWR_REQUEST_DEFAULTS },
  );

  return {
    data,
    loading: !error && !data,
    error,
    mutate,
  };
}
